import { IGetBetsPositionRequest } from '../../../../repositories/auction/v1/get-bets-position';
import { ECategory } from '../../../../repositories/monolith-python/entities/offer/OfferSchema';
import { ICoordinates, IGeoAddressItem, IOfferState } from '../../../../types/reducers/offer';
import { EServiceId } from '../../../../types/reducers/publishTerms';
import { getBetPositionServices } from './getBetPositionServices';
import {
  EConcurrencyType,
  EGeoType,
} from '../../../../repositories/auction/entities/AnnouncementsBets/GetBetsPositionRequest';

interface IGetBetPositionParams {
  serviceIds: EServiceId[];
  offer: IOfferState;
  childLocation: IGeoAddressItem | null;
  coordinates: ICoordinates;
  currentBet: number;
  isAuctionEnabled: boolean;
}

export function getBetPositionParams(params: IGetBetPositionParams): IGetBetsPositionRequest {
  const {
    serviceIds,
    offer: { category, id, bargainTerms },
    childLocation,
    coordinates: { lat, lng },
    currentBet,
    isAuctionEnabled,
  } = params;

  const geoId = childLocation?.id || undefined;
  const geoType = (childLocation?.type as unknown as EGeoType) || undefined;

  const services = getBetPositionServices({
    serviceIds,
    currentBet,
    isAuctionEnabled,
  });

  return {
    concurrencyType: EConcurrencyType.Local,
    announcementId: id || undefined,
    price: bargainTerms.price,
    geoId,
    geoType,
    category: category as ECategory,
    services,
    lat,
    lon: lng,
  };
}
